export class Page<
  EventType = Event,
  ClickEvent extends (selector: string, type: 'click', callback: (e: EventType) => void) => void = (
    selector: string,
    type: 'click',
    callback: (e: EventType) => void,
  ) => void,
> {
  /** 首次 enter 的时候为true */
  mounted = false;
  constructor({
    beforeEnter,
    enter,
    leave,
    beforeLeave,
    init,
    clickEvents,
    eventTrigger,
  }: {
    beforeEnter?: () => void | Promise<void>;
    enter?: () => void | Promise<void>;
    beforeLeave?: () => void | Promise<void>;
    leave?: () => void | Promise<void>;
    init?: () => void;
    eventTrigger?: ClickEvent;
    /** init 之后一次性注册的事件 */
    clickEvents?: Record<string, (e: EventType) => void>;
  }) {
    this.beforeEnter = beforeEnter;
    this.enter = enter;
    this.beforeLeave = beforeLeave;
    this.leave = leave;
    this.init = init;
    this.eventTrigger = eventTrigger;
    this.clickEvents = clickEvents;
  }
  eventTrigger?: ClickEvent;
  clickEvents?: Record<string, (e: EventType) => void>;
  beforeEnter?: () => void | Promise<void>;
  enter?: () => void | Promise<void>;
  beforeLeave?: () => void | Promise<void>;
  leave?: () => void | Promise<void>;
  init?: () => void | Promise<void>;
}

export class PageManager<PageType extends string> {
  pages: Record<PageType, Page> = {} as Record<PageType, Page>;
  currentPage?: Page;

  constructor({ pages }: { pages: Record<PageType, Page> }) {
    this.pages = pages;

    for (const page of Object.values<Page>(pages)) {
      try {
        page.init?.();
        page.mounted = true;
        if (page.eventTrigger) {
          for (const [selector, callback] of Object.entries(page.clickEvents || {})) {
            page.eventTrigger(selector, 'click', callback);
          }
        }
      } catch (err) {
        console.log('init page error', err);
      }
    }
  }

  async changePage(page: Page) {
    const lastPage = this.currentPage;
    this.currentPage = page;

    await lastPage?.beforeLeave?.();
    await page.beforeEnter?.();

    await lastPage?.leave?.();
    await page.enter?.();
  }
}
